// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__37YLY","col":"styles_col__Es02v"};